import { render } from "./EffectSlider.vue?vue&type=template&id=2d0a5fd5&scoped=true"
import script from "./EffectSlider.vue?vue&type=script&lang=js"
export * from "./EffectSlider.vue?vue&type=script&lang=js"

import "./EffectSlider.vue?vue&type=style&index=0&id=2d0a5fd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0a5fd5"]])

export default __exports__